module.exports = __webpack_public_path__ + "static/taro-d605a60d263bc5397093a747f9bcce34.png";